import { useEffect, useState } from "react";
import { reconcileAfterOidcRedirect } from "../state/AuthContext";

// Landing spot for the redirect back from whichever OIDC provider is
// configured (Keycloak, Authelia, Google, an operator's own Authentik
// instance — generic, never a named provider). Per AuthContext.tsx's header comment,
// the real backend contract handles the OIDC exchange entirely server-side
// at GET /api/auth/oidc/callback (a backend route, not this one) and sets a
// session cookie before sending the browser onward — so this frontend route
// is a defensive fallback for whatever URL the backend chooses to land on,
// not the primary path. There is no token to read out of the query string
// in this contract; all this does is re-check GET /api/auth/me (which will
// now succeed if the cookie was set) and bounce home.
export function AuthCallback({ search }: { search: URLSearchParams }) {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const oidcError = search.get("error");
    if (oidcError) {
      setError(search.get("error_description") || oidcError);
      return;
    }
    let cancelled = false;
    (async () => {
      const user = await reconcileAfterOidcRedirect();
      if (cancelled) return;
      if (!user) {
        setError("Sign-in completed but the session could not be confirmed.");
        return;
      }
      window.location.replace(window.location.pathname + window.location.search + "#/");
      window.location.reload();
    })();
    return () => {
      cancelled = true;
    };
  }, [search]);

  return (
    <div className="auth-screen">
      <div className="auth-card">
        {error ? (
          <>
            <h2>Sign-in failed</h2>
            <p className="auth-error">{error}</p>
            <a className="button-link" href="#/login">
              Back to sign in
            </a>
          </>
        ) : (
          <p>Completing sign-in…</p>
        )}
      </div>
    </div>
  );
}
